import { useEffect, useMemo } from 'react'
import debounce from 'lodash.debounce'
import { NATURAL_LANGUAGE_SEARCH_DEBOUNCE_MS } from 'constants/naturalLanguageSearch'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { extractDatesAction, extractOccupancyAction } from 'actions/SearchActions'

export interface UseNaturalLanguageSearchConfig {
  debounceMs?: number
  searchTermThreshold?: number
}

export const useExtractDatesAndOccupancy = (searchTerm: string | undefined, config: UseNaturalLanguageSearchConfig = {}) => {
  const {
    debounceMs = NATURAL_LANGUAGE_SEARCH_DEBOUNCE_MS,
  } = config

  const extractedDates = useAppSelector((state: App.State) => state.search.extractedDates[searchTerm ?? ''])
  const extractedOccupancy = useAppSelector((state: App.State) => state.search.extractedOccupancies[searchTerm ?? ''])
  const dispatch = useAppDispatch()

  const extractDatesAndOccupancy = useMemo(() => debounce((input: string) => {
    dispatch(extractDatesAction(input))
    dispatch(extractOccupancyAction(input))
  }, debounceMs), [dispatch, debounceMs])

  useEffect(() => {
    if (!searchTerm) return

    extractDatesAndOccupancy(searchTerm)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchTerm])

  return {
    extractedDates,
    extractedOccupancy,
  }
}
